export default __webpack_public_path__ + "static/media/realtime.855f60e7.svg";